const round2 = (n) => Number(n.toFixed(2));

// Subtotal de un item (price * qty, redondeado a centavos) — misma formula que usa
// la normalizacion de CartDrawer.jsx, para poder calcularlo tanto desde items ya
// normalizados (con .subtotal) como desde items crudos del carrito (con .price/.qty).
const itemSubtotal = (it) => {
  if (it.subtotal !== undefined && it.subtotal !== null) return Number(it.subtotal);
  const price = Number(it.price ?? it.unitPrice ?? 0);
  const qty = Number(it.qty ?? it.quantity ?? 1);
  return Math.round(Math.round(price * 10000) * qty / 100) / 100;
};

// Formula unica del total del pedido/carrito — usada tanto por buildOrderPayload
// (al confirmar la orden) como por useBudgetStatus (gauge de presupuesto en vivo),
// para que los dos porcentajes mostrados siempre coincidan con el mismo carrito.
export function computeCartTotal(items, user) {
  const porcentaje = Number(user?.porcentaje || 0) / 100;
  const validItems = (items || []).filter(
    (it) => it.idProduct != null || it.productId != null || it.code != null
  );

  const subTotal0 = round2(
    validItems.filter((it) => !it.payTax).reduce((acc, it) => acc + itemSubtotal(it), 0)
  );

  const gravado = round2(
    validItems.filter((it) => it.payTax).reduce((acc, it) => acc + itemSubtotal(it), 0)
  );

  const gravadoNoServ = validItems
    .filter((it) => it.payTax && it.service !== 1)
    .reduce((acc, it) => acc + itemSubtotal(it), 0);
  const ivaTotal = round2(Math.round(gravadoNoServ * porcentaje * 100) / 100);

  const gravadoServ = validItems
    .filter((it) => it.service === 1)
    .reduce((acc, it) => acc + itemSubtotal(it), 0);
  const ivaServicios = round2(Math.round(gravadoServ * porcentaje * 100) / 100);

  const total = round2(gravado + subTotal0 + ivaTotal + ivaServicios);

  return { subTotal0, gravado, ivaTotal, ivaServicios, total };
}

export function buildOrderPayload({ items, user, claseOverride = "*", pedidoNumber = null, crossId = null, carNumber = null, noComps = null }) {
  const salesman = JSON.parse(localStorage.getItem("salesman"));
  const validItems = items.filter(
    (x) => x.idProduct != null || x.productId != null || x.code != null
  );
  const valorBruto = Number(
    validItems.reduce((acc, it) => acc + Number(it.subtotal), 0).toFixed(2)
  );

  const { subTotal0, gravado, ivaTotal, ivaServicios, total: totalFinal } = computeCartTotal(items, user);

  return {
    idCustomer: user.idCustomer,
    idShipTo: user.idShipTo,
    taxPerc: Number(user.porcentaje),
    myaccountId: user.myaccountId,
    companyId: user.companyId,
    bodegaId: user.bodegaId,
    aplicacion: "F",
    tipo: "PE",
    clase: claseOverride,
    priceType: user.priceType,
    creditTermId: user.creditTermId,
    idSalesman: salesman?.idSalesman ?? user.idSalesman,
    salesmanId: salesman?.salesmanId ?? user.salesmanId,
    idEmployee: user.idEmployee,
    groupId: user.groupId,

    items: validItems.map((x) => ({
      idProduct: x.idProduct,
      code: x.code ?? x.productId,
      description: x.description ?? x.productName,
      notes: x.notes || null,
      quantity: Number(x.qty),
      unitPrice: Number(x.price),
      totalPrice: Number(x.subtotal),
      taxValue: Number(x.tax),
      tax: x.payTax ? Number(user.porcentaje) : 0,
      payTax: x.payTax === true,
      service: x.service === 1,
      acuerdo: x.acuerdo ?? false,
    })),

    totalExento: subTotal0,
    subtotal: valorBruto,
    taxable: gravado,
    taxTotal: ivaTotal,
    serviceTax: ivaServicios,
    services: 0.0,
    total: totalFinal,
    pedidoNumber,
    crossId,
    carNumber,
    noComps,
  };
}
